import { FormFieldBase } from './form-field-base.model';

export class FormFieldFileManager extends FormFieldBase<string> {
  override controlType = 'file-manager';
}
